module.exports = __webpack_public_path__ + "img/m7-real-estate.3588cbdb.svg";